module.exports = __webpack_public_path__ + "img/sydney_vet_splash.cc227a6e.jpg";